
<agpr-dialog-container
    id="briefing.warningMessageDialog.warningMessageDialog"
    [heading]="header"
    (onHide)="cancel()"
>
    <div
        class="agpr-importWarningDialog-content"
        [innerHTML]="'Briefings.importTool.warningMessage' | localize"
    ></div>

    <ng-template #footerLeft>
        <agpr-button
            label="cancel"
            id="briefing.warningMessageDialog.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            label="continue"
            (click)="ok(false)"
            id="briefing.warningMessageDialog.warningContinueButton"
            [style]="buttonTypes.secondary"
        ></agpr-button>
        <agpr-button
            label="Briefings.importTool.button.addAndContinue"
            [style]="buttonTypes.primary"
            (click)="ok(true)"
            [id]="'briefing_warningMessageDialog_warningAddAndContinueButton'"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
